import React, { Component } from "react";
import { toast } from "react-toastify";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import { Badge, Button } from "react-bootstrap";
import { formatNumber } from "../services/util";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { getAllInvoices } from "../services/dashboardService";
import PageLoading from "./common/pageLoading";
import { RiDeleteBin2Line } from "react-icons/ri";

class AllInvoices extends Component {
  state = {};

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    await this.getAllInvoices();
  }

  async getAllInvoices() {
    try {
      let invoices = [];
      const { data } = await getAllInvoices();
      invoices = data;
      this.setState({ invoices });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  //   handleSearch = async (e) => {
  //     this.setState({ loading: true });
  //     const { currentPage, pageSize } = this.state;
  //     const value = e.currentTarget.value;
  //     this.setState({ searchQuery: value, currentPage: 1 });
  //     await this.populateTransactions(currentPage, pageSize, value);
  //   };

  render() {
    const { invoices, loading } = this.state;

    return (
      <React.Fragment>
        <div className="card">
          <div className="card-header main-color-bg">
            <h5>Invoices</h5>
          </div>
          <div className="card-body">
            <span className="card-text">
              {loading && <PageLoading loading={loading} />}
              {!loading && invoices.length === 0 && <span className="float-left mt-4">No Invoices to Display</span>}
              {!loading && invoices.length > 0 && (
                <TableContainer component={Paper} className="mt-4">
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Invoice Number</StyledTableCell>
                        <StyledTableCell align="right">Date</StyledTableCell>
                        <StyledTableCell align="right">Equipment</StyledTableCell>
                        <StyledTableCell align="right">Status</StyledTableCell>
                        <StyledTableCell align="right">Total</StyledTableCell>
                        <StyledTableCell align="right">Amount Payable</StyledTableCell>
                        <StyledTableCell align="right"></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoices.map((invoice) => (
                        <StyledTableRow key={invoice._id}>
                          <StyledTableCell component="th" scope="row">
                            {invoice.invoiceNumber}
                          </StyledTableCell>
                          <StyledTableCell align="right">{invoice.formattedDate}</StyledTableCell>
                          <StyledTableCell align="right">{invoice.equipmentName}</StyledTableCell>
                          <StyledTableCell align="right">
                            <Badge variant={`${invoice.status === "Pending" ? "warning" : "success"}`}>
                              {invoice.status}
                            </Badge>
                          </StyledTableCell>
                          <StyledTableCell align="right">NGN {formatNumber(invoice.totalAmount)}</StyledTableCell>
                          <StyledTableCell align="right">NGN {formatNumber(invoice.amountPayable)}</StyledTableCell>
                          <StyledTableCell align="right">
                            {invoice.status === "Pending" && invoice.amountPayable === invoice.totalAmount && (
                              <Button variant="danger" className="mb-3 mr-2" onClick>
                                <RiDeleteBin2Line />
                              </Button>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AllInvoices;
